module.exports = __webpack_public_path__ + "static/media/Drawflow_App_recording.2631aa19.mp4";